import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Zap, Sparkles } from "lucide-react";
import { Dialog, DialogContent, DialogTitle } from "@/components/ui/dialog";

const FEATURE_COPY = {
  translate: { title: "Translate without limits", body: "Free plans include 25 translations a day. BLOQ+ removes the cap so Babel keeps every chat in your language." },
  smart_replies: { title: "Unlimited Smart Replies", body: "You've used today's 20 free Smart Replies. BLOQ+ keeps the suggestions coming." },
  assistant: { title: "Keep chatting with @bloq", body: "Free plans get 15 assistant messages a day. BLOQ+ lifts the limit." },
  ai_summary: { title: "Catch up on every chat", body: "Free plans include 3 AI summaries a day. BLOQ+ gives you unlimited catch-ups." },
  pin_top: { title: "Pin more BLOQs", body: "Free plans can pin 3 BLOQs to the top. BLOQ+ lets you pin as many as you like." },
  hd_image: { title: "Send HD photos", body: "HD image uploads are a BLOQ+ perk — or send a smaller image for free." },
};

// §13.4 shared upsell sheet: opens on the `bloq:upsell` window event dispatched by the axios 429
// interceptor (upgrade_required) or by callers via showUpsell(). Deep-links into Billing.
export function showUpsell(detail) {
  window.dispatchEvent(new CustomEvent("bloq:upsell", { detail }));
}

export function UpsellSheet() {
  const [info, setInfo] = useState(null);
  const navigate = useNavigate();
  useEffect(() => {
    const on = (e) => setInfo(e.detail || {});
    window.addEventListener("bloq:upsell", on);
    return () => window.removeEventListener("bloq:upsell", on);
  }, []);
  if (!info) return null;
  const copy = FEATURE_COPY[info.feature] || { title: "Unlock more with BLOQ+", body: info.message || "You've reached a free-plan limit. Upgrade to keep going." };
  const plan = info.plan || "bloq_plus";
  return (
    <Dialog open onOpenChange={(o) => !o && setInfo(null)}>
      <DialogContent className="max-w-sm border-white/10 bg-bloq-s1 text-white" data-testid="upsell-sheet">
        <div className="flex h-12 w-12 items-center justify-center rounded-2xl bg-gradient-to-br from-bloq-mint/25 to-bloq-blue/10 text-bloq-mint ring-1 ring-inset ring-bloq-mint/40">
          <Zap className="h-6 w-6" />
        </div>
        <DialogTitle className="mt-3 font-heading text-xl font-bold" data-testid="upsell-title">{copy.title}</DialogTitle>
        <p className="text-sm text-bloq-muted" data-testid="upsell-body">{copy.body}</p>
        {info.message && FEATURE_COPY[info.feature] && <p className="text-xs text-bloq-muted/80">{info.message}</p>}
        <div className="mt-4 flex flex-col gap-2">
          <button
            onClick={() => { setInfo(null); navigate(`/app/membership?upgrade=${plan}&ref=upsell_${info.feature || "limit"}`); }}
            className="flex items-center justify-center gap-2 rounded-full bloq-gradient py-3 text-sm font-bold text-bloq-bg hover:opacity-90"
            data-testid="upsell-upgrade-btn"
          >
            <Sparkles className="h-4 w-4" /> Upgrade to BLOQ+
          </button>
          <button onClick={() => setInfo(null)} className="rounded-full border border-white/10 py-2.5 text-sm text-bloq-muted hover:text-white" data-testid="upsell-dismiss-btn">
            Not now
          </button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
